// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1PSe-","container":"styles_container__3ZCnG","title":"styles_title__CY_r_","wrapper":"styles_wrapper__3m4Fb","answer":"styles_answer__fevmx"};